<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 施設属性情報の説明
  </div>

<div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

  <mat-card appearance="outlined" class="manual-card">
    <mat-card-header>
      <mat-card-title><span>施設属性情報の説明</span></mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <div class="manual-img">
        <img src="assets/img/manual/facility-attr.png" width="100%">
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/A.png"> 追加ボタン
      </div>
      <div class="manual-explain">
        クリックすることで追加画面が表示されます。
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/B.png"> 削除ボタン
      </div>
      <div class="manual-explain">
        クリックすることで選択した情報を削除します。<br>
        ボタンは、一覧の削除チェックボックスにチェックを入れる事で活性化されます。
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/C.png"> Filter
      </div>
      <div class="manual-explain">
        施設属性情報一覧に表示されているデータのフィルタリングを行います。<br>
        ※フィルタリングの対象: ID、名称
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/D.png"> 施設属性一覧
      </div>
      <div class="manual-explain">
        登録済みの施設属性情報の一覧が表示されます。<br>
        編集アイコンをクリックすることで編集画面が表示されます。<br>
      </div>

    </mat-card-content>
  </mat-card>
  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Facility Attributes
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Facility Attributes</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_facility-attr.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Add Button
        </div>
        <div class="manual-explain">
          Clicking this button will display the add screen.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Delete Button
        </div>
        <div class="manual-explain">
          Clicking this button will delete the selected information.<br>
          The button becomes active when the delete checkbox in the list is checked.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter
        </div>
        <div class="manual-explain">
          Filters the data displayed in the facility attributes list.<br>
          * Filtering criteria: ID, name
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Facility Attributes List
        </div>
        <div class="manual-explain">
          Displays a list of registered facility attribute information.<br>
          Clicking the edit icon will open the edit screen.<br>
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>  
</div>
